import { FunctionComponent } from 'react';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import clsx from 'clsx';
import { NewBookingAlert } from '@spike/new-booking-model';
import { AlertNewBooking } from './AlertNewBooking';
import styles from './BookingAlertList.module.scss';

interface Props {
    alerts?: Array<NewBookingAlert>;
    className?: string;
    // Smaller variant shown under a session card.
    compact?: boolean;
}

export const BookingAlertList: FunctionComponent<Props> = ({ alerts, className, compact }) => {
    if (!alerts || alerts.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            {alerts.map((alert, index) => (
                <div
                    key={`booking_div_${alert.alertType}_${index}_alert`}
                    id={`booking_div_${alert.alertType}_alert`}
                >
                    <AlertNewBooking
                        className={clsx(styles.alert, { [styles.compact]: compact })}
                        bWidth="2px"
                        icon={faInfoCircle}
                        iconSize={compact ? 'sm' : 'lg'}
                        iconColor="#BAA997"
                        bgColor="#F8F5F1"
                        bdColor="#BCB8AE"
                    >
                        <span className={styles.alertText}>{alert.message}</span>
                    </AlertNewBooking>
                </div>
            ))}
        </div>
    );
};

export default BookingAlertList;
